<template>
  <div class="gemx-control control-group rounded-medium">
    <slot name="label"></slot>
    <slot name="childs"></slot>
    <slot name="info"></slot>
  </div>
</template>
